import { ANNOTATION_TYPES } from "@swiggy-private/checkout-core";
import { IconHome, IconMarker, IconRestaurant, IconWork, IconCircle, LineIcon } from "@swiggy-private/payment-ui";
import { ReactElement } from "react";

export const TEXTS = {
    X_ITEMS_Y_ETA: "{0} Items | ETA: {1}",
    ONE_ITEM_X_ETA: "1 Item | ETA: {0}",
    X_ITEMS: "{0} Items",
    ONE_ITEM: "1 Item",
    X_ETA: "ETA: {0}",
    DELIVERY_IN: "Delivery in: {0}",
    DELIVERING: "Delivering: ",
};

export const OTHER_ANNOTATION = "Other";

export const ICON_RESTAURANT = IconRestaurant;
export const ICON_MARKER = IconMarker;
export const ICON_HOME = IconHome;
export const ICON_WORK = IconWork;
export const ICON_STORE = IconRestaurant;
export const ICON_CIRCLE = IconCircle;
export const ICON_LINE = LineIcon;

export const ADDRESS_ANNOTATION_TYPES = {
    HOME: "Home",
    WORK: "Work",
    FRIENDS_AND_FAMILY: "Friends and Family",
};

export const ANNOTATION_ICONS = {
    [ANNOTATION_TYPES.HOME.toLowerCase()]: ICON_HOME,
    [ANNOTATION_TYPES.WORK.toLowerCase()]: ICON_WORK,
} as Record<string, () => ReactElement>;

export const PICKUP_ANNOTATION_TYPES = {
    STORE: "store",
};

export const PICKUP_ANNOTATION_ICONS = {
    [PICKUP_ANNOTATION_TYPES.STORE]: ICON_STORE,
} as Record<string, () => ReactElement>;

export const IRCTC_DELIVERY_ANNOTATION = "Delivery on seat: {0}-{1}";
